export default __webpack_public_path__ + "static/media/katogenic.80e5da0c.png";